import { AxiosResponse } from 'axios';
import { useSearchParams } from 'react-router-dom';

import Resolver from 'src/common/Resolver';
import useCheckinsStore from 'src/stores/checkinsStore';
import useParticipantsStore from 'src/stores/participantsStore';
import useSystemOptionsStore from 'src/stores/systemOptionsStore';
import useUsersStore from 'src/stores/usersStore';

import Participants from './Participants';

const ParticipantsResolver = () => {
  const [searchParams] = useSearchParams();
  const fetchParticipants = useParticipantsStore(s => s.fetchParticipants);
  const fetchCheckins = useCheckinsStore(s => s.fetchCheckins);
  const fetchUsers = useUsersStore(s => s.fetchUsers);
  const activeEditionId = useSystemOptionsStore(s => s.activeEditionId);

  const loadDependencies = () => {
    const editionFromUrl = searchParams.get('editionId');
    // Missing editionId → default to active (same as URL filter hook). Empty string = "All".
    const editionId =
      editionFromUrl !== null ? editionFromUrl || undefined : activeEditionId || undefined;

    const ownerUserId = searchParams.get('ownerUserId') || undefined;

    const deps: Array<Promise<void | AxiosResponse<unknown>>> = [
      fetchParticipants({
        editionId,
        ownerUserId,
      }),
      fetchCheckins(),
      fetchUsers(),
    ];

    return Promise.all(deps);
  };

  return <Resolver resolve={loadDependencies} successComponent={Participants} />;
};

export default ParticipantsResolver;
